import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_2 = {
  key: 1,
  class: "error-state"
}
const _hoisted_3 = { class: "error-content" }

import TopNav from "@/components/TopNav.vue";
import ToastContainer from "@/components/ToastContainer.vue";
import { useAuth } from "@/composables/useAuth";
import { onMounted } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { 
  isInitialized, 
  initializationError, 
  initializeMsal 
} = useAuth();

// Trigger MSAL initialization when the App component mounts
onMounted(async () => {
  try {
    await initializeMsal();
  } catch (err) {
    console.error("App.vue: Initialization failed", err);
  }
});

const retryInitialization = async () => {
  try {
    await initializeMsal();
  } catch (err) {
    console.error("App.vue: Retry initialization failed", err);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TopNav),
    _createElementVNode("main", null, [
      (!_unref(isInitialized))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "loading-content" }, [
              _createElementVNode("div", { class: "loading-spinner" }),
              _createElementVNode("p", null, "Loading authentication...")
            ], -1)
          ])))
        : (_unref(initializationError))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[1] || (_cache[1] = _createElementVNode("h3", null, "Authentication Error", -1)),
                _createElementVNode("p", null, _toDisplayString(_unref(initializationError).message), 1),
                _createElementVNode("button", { onClick: retryInitialization }, "Retry")
              ])
            ]))
          : (_openBlock(), _createBlock(_component_router_view, { key: 2 }))
    ]),
    _createVNode(ToastContainer)
  ], 64))
}
}

})